export default __webpack_public_path__ + "static/media/890.679ebe85.png";